import React from 'react';
import { Modal } from '../../../../../../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../../../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalHeader } from '../../../../../../../../../../CommonComponents/OPL/Modal/ModalHeader';

interface Props {
  onClose(): void;
  children: React.ReactNode;
}

export const ModalWrapper = ({ children, onClose }: Props) => {
  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      aria={{ labelledby: 'benefits-modal-title' }}
      size="large"
      css={{ borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px', overflow: 'hidden' }}
    >
      <ModalHeader id="benefits-modal-title">Annual Benefits Summary</ModalHeader>

      <ModalCloseButton onClick={onClose} />

      <ModalBody css="padding:0">{children}</ModalBody>
    </Modal>
  );
};
